"use strict"

// nette dočasně vypnutí některých featurek //
let IS_NETTE = document.currentScript?.matches?.('[nonce]');

let addzero = (val=0, digits=2) => {
    while (val.toString().length<digits) val = '0'+val;
    return val;
}

let serverClock=(microtime)=>{
    if (!serverClock.inited) {
        serverClock.inited=true;
    }
    if (microtime) {

        clearInterval(serverClock.interval);
        
        serverClock.target=document.querySelectorAll('.-js-server-time');
        if (serverClock.target.length) { serverClock.interval=setInterval(serverClock, 200); }

        serverClock.microtime=microtime;
        serverClock.now=performance.now();

    }
    let date=new Date(Math.round(serverClock.microtime+(performance.now()-serverClock.now)));

    let date_text=window.gl_lang_code=='cs'
        ?
            addzero(date.getDate())
            +'.'
            +addzero(date.getMonth()+1)
            +'.'
            +addzero(date.getFullYear(),4)
            +' '
            +addzero(date.getHours())
            +':'
            +addzero(date.getMinutes())
            +':'
            +addzero(date.getSeconds())
            
        :
            addzero(date.getFullYear(),4)
            +'-'
            +addzero(date.getMonth())
            +'-'
            +addzero(date.getDate())
            +' '
            +addzero(date.getHours())
            +':'
            +addzero(date.getMinutes())
            +':'
            +addzero(date.getSeconds())

    ;
    
    serverClock.target.forEach((element)=>{
        element.innerText=date_text;
    });
    
    
}

let modal=(show)=>{
    if (typeof window.$?.()?.modal === 'function') {
        if ( show && !window.$?.('#modalLogoutWarn').is(":visible")) {
            window.$?.('#modalLogoutWarn').modal('show');
        } else if ( !show ) {
            window.$?.('#modalLogoutWarn').modal('hide');
        }    
    }

    if (typeof window.Modal === "function") {
        if (!window.modalLogoutWarnObj) {
            window.modalLogoutWarnObj = new Modal(document.getElementById('modalLogoutWarn'), {backdrop: 'static', keyboard: false});
        }

        if ( show && !window.modalLogoutWarnObj._isShown) {
            window.modalLogoutWarnObj.show();
        } else if ( !show ) {
            window.modalLogoutWarnObj.hide();
        }
    }
}

let nonPersistentNotification = (title, body) => {
    if (!('Notification' in window) || Notification.permission !== 'granted') {
        // alert('Notification API not supported!');
        return;
    }

    try {
        let notification = new Notification(title, {
            icon: gl_url_www + "i/www_base/img/loga_png/T-red.png",
            body: body,
        });
    } catch (err) {
        console.error(err);
        // alert('Notification API error: ' + err);
    }
}

let logoutNotificationSent = false;
let edClock=(data)=>{
    document.querySelectorAll('.edClock').forEach((e)=>{
        e.innerText = (data.zbyva_min||0) + ' min';
        e.title = data.msg || '';
    });

    let modalLogoutWarn = document.querySelector('#modalLogoutWarn');

    console.log(data);
    // OBŠLEHNUTO ZE STARÉHO JQ; želbohu modaly a tak...
    if (data.msgLogoutWarn && modalLogoutWarn) {
        let refreshLogout = document.querySelector('.refresh-logout');
        let refreshClose = document.querySelector('.refresh-close');
        let refreshLogin = document.querySelector('.refresh-login');

        // d-none kvuli bs5
        if (data.zbyva_sec < 0) {
            refreshLogout.classList.add('hide', 'd-none');
            refreshClose?.classList?.remove('hide', 'd-none');
            refreshLogin.classList.remove('hide', 'd-none');
        } else {
            refreshLogout.classList.remove('hide', 'd-none');
            refreshClose?.classList?.add('hide', 'd-none');
            refreshLogin.classList.add('hide', 'd-none');
        }

        document.querySelector('#modalLogoutBody').innerHTML = data.msgLogoutWarn;

        modal(true);
    } else {
        modal(false);
    }

    if (!logoutNotificationSent && data.zbyva_min < 5 && data.msgLogoutWarn) {
        logoutNotificationSent = true;
        nonPersistentNotification(window.jstr('Automatické odhlášení'), data.msgLogoutWarn.replace(/(<([^>]+)>)/gi, ""));
    } else if (data.zbyva_min > 5) {
        logoutNotificationSent = false;
    }
}

let clock=()=>{
    
    clearTimeout(clock.timeout);
    clock.timeout=setTimeout(clock, 61000);

    let t0;
    
    // použiju vlastní request, získám tak nejpřesnější údaj o době stahování odpovědi == zpřesnění serverového času //
    
    let rqst = new XMLHttpRequest();
    rqst.onreadystatechange=()=>{  
        if (rqst.readyState == 2) { t0=performance.now(); } // odpověď je k dispozici
        if ((rqst.readyState == 4)&&(rqst.status == 200)) {
            let ret=JSON.parse(rqst.responseText);
            if (ret.server_time) {
                let dif=(performance.now()-t0); // přičtu čas stahování
                let microtime = ret.server_time*1000 + dif;
                serverClock(microtime);
            }
            if (IS_NETTE) return;
            edClock(ret);
            if (ret.zbyva_sec>0) {
                clearTimeout(clock.timeout);
                clock.timeout=setTimeout(clock, ((ret.zbyva_sec%60)+1)*1000);
            }
        }
    }

    if (window.VutAppConfig) {
        rqst.open('GET', window.VutAppConfig.baseUrlWww + "/clock.php?lang=" + window.VutAppConfig.langCode, true);
    } else {
        rqst.open('GET', window.gl_url_www + "www_base/clock.php?lang=" + window.gl_lang_code, true);
    }
    rqst.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    rqst.send();
    
}

window.addEventListener('DOMContentLoaded', ()=>{
    clock();
    window.addEventListener('focus', clock, false);
    if (IS_NETTE) return;
    document.querySelectorAll('#modalLogoutWarn #refreshLogin').forEach((e)=>{
        e.addEventListener('click', event => {
            let win;
            event.stopPropagation();

            if (window.VutAppConfig && event.target.dataset.url) {
                win = window.open(window.VutAppConfig.urlWww + event.target.dataset.url, 'refreshLoginWin');
            } else {
                win = window.open(window.gl_url_www + window.gl_lang_code + "/login?closeafter=1", 'refreshLoginWin');
            }
            win.focus();
        });
    });
    document.querySelectorAll('#modalLogoutWarn .refresh-logout').forEach((e)=>{
        e.addEventListener('click', ()=>{
            let rqst = new XMLHttpRequest();
            rqst.onreadystatechange=()=>{  
                if (rqst.readyState == 4) { clock(); }
            }
            if (window.VutAppConfig) {
                rqst.open('GET', window.VutAppConfig.baseUrlWww + "/session_keeper.php", true);
            } else {
                rqst.open('GET', window.gl_url_www + "session_keeper.php", true);
            }
            rqst.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
            rqst.send();
        });
    });

});
